<template>
  <div class="waiting__container">
    <div class="waitingView">
      <div class="waitingView__icon">
        <i class="icon-clock"></i>
      </div>
      <div class="waiting__text" tabindex="0" aria-live="assertive">
        <p>
          {{
            this.queue_postition > 0 ?
            $gettextInterpolate($gettext('Estás en el puesto %{ queue_position } de la cola'), {queue_position: this.queue_postition})
            :  $gettext('En cola')
          }}
        </p>
        <span>
          {{
            this.waiting_time > 0 ?
                $gettextInterpolate($gettext('El tiempo aproximado de espera es de %{ waiting_time } minutos'), {waiting_time: this.waiting_time})
                : $gettext('En breves momentos serás atendido/a por uno de nuestros agentes. Por favor, mantente a la espera')
          }}
        </span>
      </div>
    </div>
    <div class="waiting__options" tabindex="0">
      <p> {{$gettext('¿Prefieres evitar la espera?')}}</p>
      <div class="form-button-container">
        <button name="contactForm" @click="offlineForm">{{ $gettext('Formulario de contacto') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {changeChatWindowStatus} from "@/utils";
import store from "@/store";

export default {
    name: 'WaitingView',
    computed: {
      ...mapGetters(['queue_postition', 'waiting_time'])
    },
    mounted() {
      // A persisted queue status without a thread must not strand the user here.
      if (!store.state.id || !store.state.token) {
        store.http.setThreadClosed();
        changeChatWindowStatus(1);
        return;
      }
      store.http.resumeQueueRefresh();
    },
    methods:{
      offlineForm() {
        store.http.closeThread();
        store.commit('cleanMessages');
        store.commit('setId', null);
        store.commit('setToken', null);
        store.commit('setLastId', 0);
        store.commit('chatRated', false);
        changeChatWindowStatus(4);
      },
    }
}
</script>